export const GenderOptions = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Not available', value: 'not-available' }
]

export const getGenderOptionLabel = GenderOptions.map(item => item.label)
export const getGenderOptionValues = GenderOptions.map(item => item.value)
export const getGenderByLabelOrValue = (arg : string) =>   GenderOptions.find(item => item.label.toLowerCase() === arg.toLowerCase() || item.value.toLowerCase() === arg.toLowerCase())